import { render } from "./personal-info-form.vue?vue&type=template&id=58082720&scoped=true&lang=true"
import script from "./personal-info-form.vue?vue&type=script&lang=js"
export * from "./personal-info-form.vue?vue&type=script&lang=js"

import "./personal-info-form.vue?vue&type=style&index=0&id=58082720&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58082720"]])

export default __exports__